module.exports = __webpack_public_path__ + "static/media/mark.e30f261a.svg";